import React from "react";
import Admin from "./Admin";

function Login() {
  return <Admin />;
}

export default Login;
